import base from './base';
//TODO change file name to base.ts to enable typescript
export default {
    login(data) {
        return base.postNoAuth('login', data)
    },
    listUsers() {
        return base.get('users')
    },
    createOrUpdateUser (data) {
        return base.post('users/create_user', data)
    },
    deleteUser (data) {
        return base.delete('users/delete_user', data)
    }
}